import axios from 'axios';
import JSONbig from 'json-bigint';

const JSONbigString = JSONbig({ storeAsString: true });

// 创建基本的 axios 实例
const axiosInstance = axios.create({
  baseURL: SUPP_ADMIN_URL,
  timeout: 60000,
  transformResponse: [
    (data) => {
      if (typeof data === 'string') {
        try {
          return JSONbigString.parse(data);
        } catch (e) {
          logger.error('Failed to parse response data with JSONbig', {
            error: e,
            data: data.slice(0, 100) + '...', // 只记录前100个字符避免日志过大
          });
          return data;
        }
      }
      return data;
    },
  ],
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    // 获取 header 的 Authorization
    const existingAuthToken = config.headers?.Authorization;
    // 如果已经有 Authorization header，则优先使用已存在的
    if (existingAuthToken) {
      return config;
    }

    // 尝试获取用户 token
    // const email = localStorage.getItem('userEmail');
    // const userToken = localStorage.getItem(email || '');
    // if (userToken) {
    //   config.headers.Authorization = userToken;
    //   config.headers.cookie = `token=${userToken}`;
    //   return config;
    // }

    // 尝试获取飞书用户 token
    const larkUserInfo = JSON.parse(
      localStorage.getItem('userInfo') || '{}'
    ) as { id: string };

    if (larkUserInfo.id) {
      config.headers.Authorization = larkUserInfo.id;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    // 如果响应的 status 是 200-299，直接返回数据
    return response;
  },
  (error) => {
    // 处理非 2xx 状态码的响应
    const customError = {
      status: error.response?.status || 500,
      message: error.response?.data?.message || 'An unexpected error occurred',
      data: error.response?.data?.data || null,
    };

    // 在这里可以打印日志或展示通知
    console.error('API Error:', customError);

    // 将自定义的错误对象返回
    return Promise.reject(customError);
  }
);

export default axiosInstance;
